function sanitizePath(path: string): string {
  return path.replace(/\/$/, "")
}

export default function comparePaths(a: string, b: string): boolean {
  return sanitizePath(a) === sanitizePath(b)
}
